import { CalendarPetListType } from "^/customer/calendar";
import { useCalendarPetList } from "~/services/customer/calendar";
import { useCreatePet } from "~/services/customer/myPage";
import { useCallback } from "react";

const useMyPagePetInfo = () => {
  const { data: calendarPetList } = useCalendarPetList();
  const petList = calendarPetList?.map((item: CalendarPetListType) => {
    return {
      seq: item.petSeq,
      title: item.petName,
      description: item.petBreed + " | " + item.petWeight,
      description1: item.petAge,
      image: item.fileUrl || "",
    };
  });
  return {
    petList,
  };
};

// Pet 폼 데이터 타입 정의
interface PetFormData {
  userName?: string;
  userSeq?: number;
  petName?: string;
  petRegNumber?: string;
  petType?: string;
  gender?: string;
  year?: string;
  month?: string;
  day?: string;
  petWeight?: string | number;
  neuter?: string;
  personality?: string;
  inoculation?: string;
  allergy?: string;
  memo?: string;
  petImg?: string;
  fileSeq?: number;
}

// Pet 생성을 위한 폼 데이터 변환 함수
export const usePetCreateForm = () => {
  const createPetMutation = useCreatePet();

  const convertFormToPetData = useCallback((formData: PetFormData) => {
    console.log("폼 데이터:", formData); // 디버깅용

    // 생년월일 조합 - 안전하게 처리
    const year = formData.year || "";
    const month = formData.month
      ? String(formData.month).padStart(2, "0")
      : "01";
    const day = formData.day ? String(formData.day).padStart(2, "0") : "01";
    const petBirthday = `${year}-${month}-${day}`;

    console.log("생년월일:", petBirthday); // 디버깅용

    const requestData: any = {
      data: {
        userName: formData.userName || "",
        userSeq: formData.userSeq || 9007199254740991, // 실제 userSeq로 변경 필요
        petName: formData.petName || "",
        petRegNumber: formData.petRegNumber || "",
        cdPetBreed: formData.petType || "PET_BREED_001",
        cdPetGender: formData.gender || "MALE",
        petBirthday,
        fileSeq: formData.fileSeq || 9007199254740991, // 실제 fileSeq로 변경 필요
        petWeight: parseFloat(String(formData.petWeight)) || 0,
        neuterYn: formData.neuter || "N",
        inoculations: formData.inoculation || "",
        personalities: formData.personality || "",
        allergy: formData.allergy || "",
        memo: formData.memo || "",
      },
      file: formData.petImg || "",
    };

    console.log("API 요청 데이터:", requestData); // 디버깅용
    return requestData;
  }, []);

  const submitPetForm = useCallback(
    async (formData: PetFormData) => {
      try {
        const petData = convertFormToPetData(formData);
        const result = await createPetMutation.mutateAsync(petData);
        return result;
      } catch (error) {
        console.error("Pet 생성 실패:", error);
        throw error;
      }
    },
    [convertFormToPetData, createPetMutation]
  );

  return {
    submitPetForm,
    convertFormToPetData,
    isLoading: createPetMutation.isPending,
    error: createPetMutation.error,
    isSuccess: createPetMutation.isSuccess,
  };
};

export default useMyPagePetInfo;
